import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "field-group is-price-group js-group-fields",
  "data-group": "1"
}
const _hoisted_2 = { class: "field" }
const _hoisted_3 = { class: "field__price-group" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-close" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-close" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", null, _toDisplayString(_ctx.$t("search.end_date")), 1),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_DatePicker, {
          placeholder: _ctx.$t('search.from'),
          value: _ctx.endDateFrom,
          onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleDateChange('endDateFrom', $event))),
          format: "DD.MM.YYYY",
          range: false,
          "disabled-date": _ctx.disableEndDateFrom,
          onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.$emit('applyFilters')), ["enter"]))
        }, {
          "icon-clear": _withCtx(() => [
            _hoisted_4
          ]),
          "icon-calendar": _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["placeholder", "value", "disabled-date"]),
        _createVNode(_component_DatePicker, {
          placeholder: _ctx.$t('search.to'),
          value: _ctx.endDateTo,
          onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleDateChange('endDateTo', $event))),
          format: "DD.MM.YYYY",
          range: false,
          "disabled-date": _ctx.disableEndDateTo,
          onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.$emit('applyFilters')), ["enter"]))
        }, {
          "icon-clear": _withCtx(() => [
            _hoisted_6
          ]),
          "icon-calendar": _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["placeholder", "value", "disabled-date"])
      ])
    ])
  ]))
}